export default "<p>\n  action-button works!\n</p>\n";